// Make sure that we don't add the map a second time
//
document.addEventListener("turbo:before-render", (event) => {
  const newBody = event.detail.newBody
  const new_map_element = newBody.querySelector("#stations-map")
  const stationsMapElement = document.getElementById("stations-map")
  const permanentContentElement = document.getElementById("permanent-content")

  if (new_map_element && stationsMapElement && stationsMapElement.parentElement == permanentContentElement) {
    new_map_element.remove()
  } else {
    if (new_map_element && permanentContentElement && new_map_element.parentElement !== permanentContentElement) {
      permanentContentElement.appendChild(new_map_element)
    }
  }
})


